import React from "react";
import "./HouseingTransform.css";

const IndustrialTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Maintain a Safer, Cleaner Industrial Facility
        </h2>

        <p className="workplace-cta-text">
          Get specialized industrial cleaning services designed for manufacturing
          and warehouse environments
        </p>

        <a
          href="https://wa.me/919899811123?text=Industrial%20%26%20Warehouse%20Cleaning"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Request Industrial &amp; Warehouse Cleaning →
        </a>
      </div>
    </section>
  );
};

export default IndustrialTransform;
